// extracted by mini-css-extract-plugin
export default {"flag":"CountrySelect_flag__mi+Ku"};